import { useGetMyIntroductions } from '@queries/introductions';
import { withAuthGate } from '@sunrise-ui/composites';
import { Loader, useAuthStore } from '@sunrise-ui/primitives';
import InboxIntroductionView from '@templates/InboxIntroductionView';
import React from 'react';

function AcceptedIntrosScreen() {
  const { currentUserId } = useAuthStore();
  const { isLoading: isLoadingIntros, data: introductions } =
    useGetMyIntroductions({
      userId: currentUserId,
      state: 'accepted',
    });

  if (isLoadingIntros) return <Loader size="large" />;

  return (
    <InboxIntroductionView intros={introductions ?? []} variant="accepted" />
  );
}

export default withAuthGate(AcceptedIntrosScreen);
